import React, { Component } from 'react'
import Portal from 'components/Portal/Portal'
import { connect } from 'react-redux'
import { Modal } from '../Modal/Modal'
import { saveWizard } from '../Designer2/DesignerActions'
import { importToLast } from './FormManagerActions'
// import x2js from 'x2js'
// const convert = new x2js()

class ImportDialog extends Component {
  processUpload = e => {
    var reader = new FileReader()
    reader.onload = e => {
      let json = JSON.parse(reader.result)
      //json.METADATA = convert.js2xml(convert.xml2js(json.METADATA).METADATA)
      json.FORM_DEFINITION_ID = 0
      this.props.saveWizard(json, formDefinitionId => {
        if (this.props.categoryTarget) {
          this.addToCategory(formDefinitionId)
        } else {
          this.modal.closeModal(() => {
            this.props.closeAndReload()
          })
        }
      })
    }
    reader.readAsText(e.target.files[0])
  }
  addToCategory = formDefinitionId => {
    this.props.importToLast(
      { categoryId: this.props.categoryTarget, formDefinitionId: parseInt(formDefinitionId, 10) },
      () => {
        this.modal.closeModal(() => {
          this.props.closeAndReload()
        })
      }
    )
  }
  modal = null
  render() {
    const { isOpened } = this.props
    return (
      <div>
        <Portal isOpened={isOpened}>
          <Modal
            ref={ref => (this.modal = ref)}
            modalSize="toast"
            title="Import Wizards"
            hideHeader
            modalBodyClassName="import-dialog"
            closeModal={this.props.closeModal}
          >
            <p>
              Select a previously-exported <b>.json</b> file.
            </p>
            <input
              type="file"
              name="json"
              id="json"
              accept="application/json"
              className="file-input"
              onChange={this.processUpload}
            />
            <label htmlFor="json" className="file-label btn-raised btn-primary">
              Choose a json file
            </label>
          </Modal>
        </Portal>
      </div>
    )
  }
}
export default connect(
  null,
  { saveWizard, importToLast }
)(ImportDialog)



// WEBPACK FOOTER //
// ./src/components/FormManager/ImportDialog.js